export default __webpack_public_path__ + "static/media/1919.f3365f9f.png";